import { EDUCATIONS, PERSONAL_DATA, REGISTER, SKILLS, FILTER_JOB, FILTER_APPLICATION_HISTORY } from "@/constants/LocalStorageStoreKeys"

const clearLocalStorage = () =>  {
    localStorage.removeItem(EDUCATIONS);
    localStorage.removeItem(PERSONAL_DATA);
    localStorage.removeItem(SKILLS);
    localStorage.removeItem(REGISTER);
    localStorage.removeItem(FILTER_JOB);
    localStorage.removeItem(FILTER_APPLICATION_HISTORY);
}

export default clearLocalStorage;